import Immutable, { Map, Iterable, fromJS } from 'immutable';

export const LOAD_PLANNINGREQUESTS = 'LOAD_PLANNINGREQUESTS';
export const UNLOAD_PLANNINGREQUESTS = 'UNLOAD_PLANNINGREQUESTS';
export const UPDATE_PLANNINGREQUESTS = 'UPDATE_PLANNINGREQUESTS';


export default function PlanningRequests(state, action) {

    switch(action.type) {

        case LOAD_PLANNINGREQUESTS:

            if(action.loading) {
                state = state.setIn(['loading'], true);
            }

            if(action.collection) {
                state = state.setIn(['collection'], Immutable.fromJS(action.collection).groupBy(x => x.get('id')).map(x => x.first()))
            }

            if(action.lastSynced) {
                state = state.setIn(['lastSynced'], action.lastSynced);
            }

            return state;
        case UNLOAD_PLANNINGREQUESTS:

            return state;
        case UPDATE_PLANNINGREQUESTS:

            if(action.single) {
                let single = Iterable.isIterable(action.single) ? action.single : fromJS(action.singe); 
                state = state.setIn(['collection', single.get('id')], single);
            }

            return state;

            default:
    }

    return state || Map();

}